"use client";
import { useQuery } from "@tanstack/react-query";
import { React, useState } from "react";
import { fetchTopics } from "../api/topicsApi";

import TopBarSignedIn from "../components/common/TopBarSignedIn";
import SearchBar from "../components/SearchBar";
// import ForumCategoryHeader from "./ForumCategoryHeader";
import ViewToggle from "./../components/common/ViewToggle";
import CategoryGrid from "./../components/topic/CategoryGrid";
import CategoryList from "./../components/topic/CategoryList";

function TopicPage() {

  // Fetch topics
  const { data, error, isLoading } = useQuery({
    queryKey: ["topics"],
    queryFn: fetchTopics,
  });
  const [viewMode, setView] = useState("list");

  return (
    <div className="w-full bg-white min-h-screen">
      <TopBarSignedIn />
      <main className="flex flex-col gap-6 p-6 mx-auto w-full max-w-[1272px] max-sm:px-4">
        <header className="mb-4">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Thảo luận</h1>
          <p className="text-gray-600">
            Xem các chủ đề theo thứ tự đã sắp xếp để có một lộ trình nghe xem tự nhiên
          </p>
        </header>
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6">
          <div className="mb-4 md:mb-0">
            <SearchBar />
          </div>
          <ViewToggle view={viewMode} onViewChange={setView} />
        </div>

        {
          viewMode === "list" ? (
            data && <CategoryList categories={data} />
          ) : (
            data && <CategoryGrid categories={data} />
          )
        }
      </main>
      {/* <Footer /> */}
    </div>
  );
}

export default TopicPage;
